import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { TableContentForMasterCardLeafCollection } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { MasterCardLeafCollectionReportSchemaObject } from "../MasterLeafCollectionReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';
import '../Pages/tableFooter.css';

const screenCode = "MASTERCARDLEAFCOLLECTIONREPORT";

export function MasterCardLeafCollectionReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [collectionTypes, setCollectionTypes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [total, setTotal] = useState({
        totalWeight: 0,
        totalNetWeight: 0
    });

    const [leafCollectionDetails, setLeafCollectionDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        collectionTypeID: "0",
        searchDate: "",
        toDate: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        collectionType: "0",
        searchDate: "",
        toDate: ""
    });

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(MasterCardLeafCollectionReportSchemaObject).options({ allowUnknown: true });
    const contentRowNames = ["date", "collectionPointName", "collectionTypeName", "cardNumber", "netAmount", "registrationNumber", "narration"]

    const csvHeaders = [
        { label: "Date", value: "date" },
        { label: "Route name", value: "collectionPointName" },
        { label: "Collection Type Name", value: "collectionTypeName" },
        { label: "Master Card Number", value: "cardNumber" },
        { label: "Net (Kg)", value: "netAmount" },
        { label: "Registration Number", value: "registrationNumber" },
        { label: "Narration", value: "narration" }
    ];

    const [reportData, setReportData] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [leafCollectionDetails.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown(),
            getCollectionTypesForDropDown()
        )
    }, [leafCollectionDetails.factoryID])


    useEffect(() => {
    }, [reportData]);

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: target.value,
            factoryID: "0",
            routeID: "0",
            collectionTypeID: "0",

        });
        clearTableData();
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            factoryID: target.value,
            routeID: "0",
            collectionTypeID: "0",
        });
        clearTableData();
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: target.value,
        });
        clearTableData();
    }

    function handleCollectiontypeChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            collectionTypeID: target.value
        });
        clearTableData();
    }

    function handleSearchDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            searchDate: target.value
        });
        clearTableData();
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            toDate: target.value
        });
        clearTableData();
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, MasterCardLeafCollectionReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWMASTERCARDLEAFCOLLECTIONREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(leafCollectionDetails.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(leafCollectionDetails.factoryID);
        setRoutes(data);
    }

    async function getCollectionTypesForDropDown() {
        const data = await services.getAllCollectionTypesByoperationEntityID(leafCollectionDetails.factoryID);
        setCollectionTypes(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, leafCollectionDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(leafCollectionDetails);

        const result = await services.getMasterCardLeafCollectionReportData(leafCollectionDetails);
        var totalNetWeightCal = 0;

        result.forEach(x => {
            totalNetWeightCal += parseFloat(x.netAmount);
            x.netAmount = x.netAmount.toFixed(2);
            x.date = x.date.split("T")[0];
        })

        setTotal({
            ...total,
            totalNetWeight: totalNetWeightCal
        })

        var totalRecordForCsv = {
            collectionPointName: "Total",
            collectionTypeName: "",
            cardNumber: "",
            netAmount: totalNetWeightCal.toFixed(2),
            registrationNumber: "",
            narration: ""
        }

        if (result.length > 0) {
            setIsTableHide(false);
            setReportData(result);
            createDataTable(["#masterCardLeafCollectionTable", "#masterCardLeafCollectionPdfTable"]);
        }

        var csvDataRecord = _.cloneDeep(result);
        csvDataRecord.push(totalRecordForCsv);

        csvDataRecord.unshift({}, {
            date: "Date: ",
            collectionPointName: new Date().toLocaleString(),
            collectionTypeName: "User: ",
            cardNumber: tokenService.getUserNameFromToken()
        }, {});

        setCsvData(csvDataRecord);
    }

    function createDataTable(dataTables) {
        dataTables.forEach(x => {
            $(x).DataTable({
                destroy: x === '#masterCardLeafCollectionPdfTable' ? true : false,
                searching: x === '#masterCardLeafCollectionPdfTable' ? false : true,
                paging: x === '#masterCardLeafCollectionPdfTable' ? false : true,
                order: [[1, 'asc'], [0, 'asc']],
                scrollX: false,
                rowGroup: {
                    startRender: null,
                    endRender: function (rows, group) {

                        var netWeight = rows
                            .data()
                            .pluck(4)
                            .reduce(function (a, b) {
                                return a + b * 1;
                            }, 0);


                        return $('<tr/>')
                            .append('<td colSpan="4"><b>Total for ' + group + '</b></td>')
                            .append('<td style="text-align:right"><b>' + netWeight.toFixed(2) + '</b></td>')
                            .append('<td colSpan="2"><b>' + "" + '</b></td>');
                    },
                    dataSrc: 1
                }
            })
        });
    }

    function createFile() {
        var settings = {
            sheetName: 'Master Card Leaf Report',
            fileName: 'MasterCardLeafCollectionReport',
            writeOptions: {}
        }
        xlsx(csvHeaders, csvData, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: "0",
            collectionTypeID: "0",
            searchDate: "",
        });
        clearTableData();
        setErrors("");
    }

    function clearTableData() {
        setIsTableHide(true);
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            collectionType: collectionTypes[searchForm.collectionTypeID],
            date: searchForm.searchDate,
        })
    }

    function MergeGridCells(tableName) {
        var dimension_cells = new Array();
        var dimension_col = null;
        var columnCount = $(tableName + " tr:first th").length;
        for (dimension_col = 0; dimension_col <= columnCount; dimension_col++) {
            var first_instance = null;
            var rowspan = 1;
            $(tableName).find('tr').each(function () {
                var dimension_td = $(this).find('td:nth-child(' + dimension_col + ')');
                if (first_instance === null) {
                    first_instance = dimension_td;
                } else if (dimension_td.text() === first_instance.text()) {
                    dimension_td.attr('hidden', true);
                    ++rowspan;
                    first_instance.attr('rowspan', rowspan);
                } else {
                    first_instance = dimension_td;
                    rowspan = 1;
                }
            });
        }
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Master Card Leaf Collection Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={leafCollectionDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={leafCollectionDetails.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={leafCollectionDetails.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4">
                                        <InputLabel shrink id="">Collection type</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionTypeID"
                                            id="collectionTypeID"
                                            name="collectionTypeID"
                                            value={leafCollectionDetails.collectionTypeID}
                                            onChange={(e) => handleCollectiontypeChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection type--</MenuItem>
                                            {generateDropDownMenu(collectionTypes)}
                                        </Select>
                                        {errors["collectionTypeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionTypeID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md-4">
                                        <InputLabel shrink id="searchDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            type="date"
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md-4">
                                        <InputLabel shrink id="toDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="table-responsive row-top-gap">
                                                <table id="masterCardLeafCollectionTable" className="display dataTable no-footer" style={{ width: "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            <th rowSpan="2">Date</th>
                                                            <th rowSpan="2">Route name</th>
                                                            <th rowSpan="2">Collection Type Name</th>
                                                            <th rowSpan="2">Master card number</th>
                                                            <th rowSpan="2">Net (Kg)</th>
                                                            <th colSpan="2">Supplier</th>
                                                        </tr>
                                                        <tr>
                                                            <th>Registration Number</th>
                                                            <th>Narration</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <TableContentForMasterCardLeafCollection
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <th colSpan="4">Total</th>
                                                            <th style={{textAlign: "right"}}>{total.totalNetWeight.toFixed(2)}</th>
                                                            <th colSpan="2"></th>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Master Card Leaf Collection Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} total={total}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
